import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Smile } from 'lucide-react';
import { Popover, PopoverContent, PopoverTrigger } from './ui/popover';
import { NOAH_STICKERS } from '../lib/noahStickers';

/** Selector de stickers de Noah para que el agente humano los envíe en el chat. */
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const StickerPicker = ({ onPick, disabled, testId = 'sticker-picker' }) => {
  const [open, setOpen] = useState(false);
  const [customs, setCustoms] = useState([]);

  useEffect(() => {
    if (!open) return;
    axios.get(`${API}/noah/stickers/custom`)
      .then((r) => setCustoms(r.data?.stickers || []))
      .catch(() => setCustoms([]));
  }, [open]);

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button
          type="button"
          disabled={disabled}
          data-testid={testId}
          title="Enviar un sticker de Noah"
          className="h-10 w-10 shrink-0 rounded-xl flex items-center justify-center text-muted-foreground hover:text-primary hover:bg-primary/10 disabled:opacity-40 transition-colors"
        >
          <Smile className="w-5 h-5" />
        </button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-[320px] p-3 rounded-2xl" data-testid="sticker-picker-panel">
        <p className="text-xs font-semibold mb-2 text-foreground">Stickers de Noah</p>
        <div className="grid grid-cols-3 gap-2 max-h-72 overflow-y-auto">
          {customs.map((c) => (
            <button
              key={c.key}
              onClick={() => { onPick({ key: c.key, text: c.text }); setOpen(false); }}
              data-testid={`sticker-pick-${c.key}`}
              title={c.text}
              className="p-1 rounded-xl hover:bg-primary/10 transition-colors ring-1 ring-brand-butter/50"
            >
              <img src={`${process.env.REACT_APP_BACKEND_URL}${c.image}`} alt={c.text} className="w-full h-auto" loading="lazy" />
            </button>
          ))}
          {NOAH_STICKERS.map((s) => (
            <button
              key={s.key}
              onClick={() => { onPick(s); setOpen(false); }}
              data-testid={`sticker-pick-${s.key}`}
              title={s.text}
              className="p-1 rounded-xl hover:bg-primary/10 transition-colors"
            >
              <img src={`/brand/stickers/${s.key}.png`} alt={s.text} className="w-full h-auto" loading="lazy" />
            </button>
          ))}
        </div>
      </PopoverContent>
    </Popover>
  );
};

export default StickerPicker;
